import React, { useContext } from "react";
import { CurrencyContext } from "../context";

const DisplayPrice = ({ price, symbol = "C$" }) => {
  const { convertCurrency } = useContext(CurrencyContext);
  return price ? <>{convertCurrency(price, symbol)}</> : null;
};

export default DisplayPrice;
